:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._pinMode_1ebi2_7 > ._previewRect_1ebi2_7 {
  position: absolute;
  background-color: #116dff;
  opacity: 0.5;
  border: 1px dashed rgba(255, 255, 255, 0.5); }

._pinMode_1ebi2_7 > ._blockingLayer_1ebi2_13 {
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute; }
